import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import type { FlattenSimpleInterpolation } from 'styled-components';
import { TypographyStyles } from '../../stylings';

export const RichTextComponent = styled(ReactMarkdown)<{ $fontSize: FlattenSimpleInterpolation }>`
  ${({ $fontSize }) => $fontSize}

  hr {
    all: revert;
  }

  h1 {
    ${TypographyStyles.Headings.H1}
  }

  h2 {
    ${TypographyStyles.Headings.H2}
  }

  h3 {
    ${TypographyStyles.Headings.H3}
  }

  h4 {
    ${TypographyStyles.Headings.H4}
  }

  h5 {
    ${TypographyStyles.Headings.H5}
  }

  li p {
    margin: 0;
  }
`;
